import { render } from "@/components/organisms/individualVehicleControlHistory/IndividualVehicleControlHistory.html?vue&type=template&id=4dd4ce52&external"
import script from "@/components/pages/individualVehicleControlHistory/IndividualVehicleControlHistory.js?vue&type=script&lang=js&external"
export * from "@/components/pages/individualVehicleControlHistory/IndividualVehicleControlHistory.js?vue&type=script&lang=js&external"

import "@/components/organisms/individualVehicleControlHistory/IndividualVehicleControlHistory.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__